import { tokens } from "../../../theme";
import {
  Box,
  IconButton,
  Link,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { releaseStyles } from "../styles";
import { commitUrl, pullRequestUrl } from "./serviceViewHelpers";

// Service-view commit row: 7-column grid (RELEASE | PATCH | TAG | HASH | MESSAGE | FLAG | PR).
// Patch cell is highlighted in brand-blue when patch label differs from release label —
// tessell-database-plugin-oracle spans rel-0.110.0 and rel-0.110.1.
const ServiceCommitRow = ({ commit, showJira }) => {
  const theme = useTheme();
  const { releaseView } = releaseStyles(tokens(theme.paletteId));

  const patchDiffers = commit.patchLabel !== commit.releaseLabel;

  return (
    <Box sx={releaseView.serviceRow(commit.flagKind)}>
      {/* RELEASE */}
      <Tooltip title={commit.releaseLabel} enterDelay={400}>
        <Typography sx={releaseView.releaseCellMono}>
          {commit.releaseLabel}
        </Typography>
      </Tooltip>

      {/* PATCH */}
      <Tooltip title={commit.patchLabel} enterDelay={400}>
        <Typography
          sx={
            patchDiffers
              ? releaseView.patchCellHighlight
              : releaseView.releaseCellMono
          }
        >
          {commit.patchLabel}
        </Typography>
      </Tooltip>

      {/* TAG */}
      <Typography sx={releaseView.tagCell}>{commit.tag}</Typography>

      {/* HASH */}
      <Box className="commit-hash" sx={releaseView.hashBox}>
        {commit.hash ? (
          <>
            <Link
              href={commitUrl(commit.repoName, commit.hash)}
              target="_blank"
              sx={releaseView.hashText}
            >
              {commit.hash}
            </Link>
            <Tooltip title="Copy commit hash">
              <IconButton
                size="small"
                sx={releaseView.copyButton}
                onClick={() => navigator.clipboard?.writeText(commit.hash)}
              >
                <ContentCopy sx={{ fontSize: 12 }} />
              </IconButton>
            </Tooltip>
          </>
        ) : null}
      </Box>

      {/* MESSAGE */}
      <Box sx={releaseView.messageCell}>
        <Tooltip title={commit.message} enterDelay={400}>
          <Typography sx={releaseView.messageText}>{commit.message}</Typography>
        </Tooltip>
      </Box>

      {/* FLAG */}
      <Box>
        {commit.flagKind === "double" ? (
          <Box component="span" sx={releaseView.flagChip(false)}>
            DOUBLE
          </Box>
        ) : commit.flagKind === "nodc" ? (
          <Box component="span" sx={releaseView.flagChip(true)}>
            NODC
          </Box>
        ) : null}
      </Box>

      {/* PR */}
      {commit.pr ? (
        <Link
          href={pullRequestUrl(commit.repoName, commit.pr)}
          target="_blank"
          sx={releaseView.prCell}
        >
          #{commit.pr}
        </Link>
      ) : (
        <Box />
      )}
    </Box>
  );
};

export default ServiceCommitRow;
